/**
 * Device types that support reboot functionality
 * Loaded from VUE_APP_REBOOTABLE_DEVICE_TYPES env variable (comma-separated)
 */
export const REBOOTABLE_DEVICE_TYPES = (process.env.VUE_APP_REBOOTABLE_DEVICE_TYPES || '')
	.split(',')
	.map(type => type.trim());

/**
 * Device types that require outlet number for reboot
 * Loaded from VUE_APP_OUTLET_REBOOT_DEVICE_TYPES env variable (comma-separated)
 */
export const OUTLET_REBOOT_DEVICE_TYPES = (process.env.VUE_APP_OUTLET_REBOOT_DEVICE_TYPES || '')
	.split(',')
	.map(type => type.trim());
